export default "__VITE_ASSET__Bv4QI0un__"